export default {
  inserted(el,vDir, vNode) {
      // vDir.value 有指令的参数
    //   el.addEventListener("keyup",event => {
    //       let e = event || window.event;
    //       e.target.value =  e.target.value.replace(/[^\w\-\/]/ig,'')
    //       vDir.value = e.target.value;
    //   });
    //   //失去焦点=>保留指定位小数
    //   el.addEventListener("focusout",event=>{//此处会在 el-input 的 @change 后执行
    //       let e = event || window.event;
    //       e.target.value =  e.target.value.replace(/[^\w\-\/]/ig,'');
    //       vDir.value = e.target.value;
    //   })
      el.addEventListener("input",event=>{//此处会在 el-input 的 @change 后执行
        let e = event || window.event;
        e.target.value =  e.target.value.replace(/[^\w\-\/]/ig,'');
        if(e.target.value){
            if(e.target.value.length>36){
                e.target.value = e.target.value.substring(0,35)
                vDir.value = e.target.value.substring(0,35);
            }else{
                e.target.value = e.target.value;
                vDir.value = e.target.value
            }
        }else{
          e.target.value = null
        }
    })
  }
}